
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'BristolStool',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/GD/BristolStool.vue